import axios from 'axios';
import { Env } from '../Helpers/Env';
import * as Sentry from '@sentry/react';
import useLogout from '../Hooks/LogoutAuth';

const useAsyncApi = (config = {}) => {
   const auth = useLogout();

   config.apiUrl = config.apiUrl || Env.api_url;

   const request = async (configs) => {
      const { path, method, data = null, isFormData = false, params } = configs;
      let headers = config.headers || Env.header;
      if (isFormData) {
         delete headers['Content-Type'];
         delete headers['Accept'];
      }

      try {
         const response = await axios({
            baseURL: config.apiUrl || Env.api_url,
            url: path,
            method,
            headers,
            data,
            params,
         });

         return response.data;
      } catch (err) {
         if (err.response) {
            if (err.response.status === 403) {
               auth.logoutWithoutApi();
               throw new Error('403 - Unauthorized');
            }

            window.gtagService('event', 'apiResponses', {
               event_category: 'Api Reject',
               event_label: `Rota: ${path} || Mensagem: ${err.response.data.message}`,
            });
            throw new Error(err.response.data.message || 'Erro desconhecido');
         }

         Sentry.captureException(err);
         throw new Error('Não foi possível se conectar ao servidor, tente novamente.');
      }
   };

   return {
      get: async (path, params) => await request({ method: 'GET', path, params }),
      post: async (path, data, isFormData) => request({ method: 'POST', path, data, isFormData }),
      put: async (path, data) => await request({ method: 'PUT', path, data }),
      del: async (path, data) => await request({ method: 'DELETE', path, data }),
   };
};

export default useAsyncApi;
